const HeroSection = ({ onBookClick, onDanceClick }) => {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_dozaguas-new/artifacts/v9d9m0cg_Screenshot%202026-03-18%20at%2012.56.26%20PM.png"
          alt="Doz Aguas Divine Flow Community"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A3626]/50 via-[#1A3626]/30 to-[#F9F6F0]" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center pt-20 pb-32">
        <h1
          data-testid="hero-title"
          className="font-['Cormorant_Garamond'] text-5xl md:text-7xl lg:text-8xl font-light text-white tracking-tight leading-[0.9] mb-8 opacity-0 animate-fade-in-up"
        >
          Doz Aguas
        </h1>
        <p className="text-sm md:text-base text-white max-w-2xl mx-auto leading-relaxed mb-4 opacity-0 animate-fade-in-up animation-delay-200 font-medium">
          Somatic Movement & Sound Healing
        </p>
        <p className="text-xs md:text-sm text-white/90 max-w-xl mx-auto leading-relaxed mb-10 opacity-0 animate-fade-in-up animation-delay-300 bg-[#1A3626]/50 px-6 py-4 rounded-2xl">
          Dedicated to fostering cultural enrichment and holistic community well-being through dance, sound healing, and related programs. Our mission is to foster personal growth, community connection, and cultural preservation while offering inclusive and accessible wellness practice.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
